import gql from 'graphql-tag'

const getSpecialPrice = gql`
query getSpecialPrice($id: ID!) {
	cashAssist {
		getSpecialPrice(id: $id) {
			id
			mod_ver
			type
			weekDays
			dateInterval {
				from
				to
			}
			timeInterval {
				from
				to
			}
			price
			priceInCafe
			tradePrice {
				count
				price
			}
			actionAmount {
				more
				less
			}
			actionDiscount
			actionGroup
			fullDiscount
			codeMWSt
			codeMWSt2
			mode
			cashRegisterId
			name
		}
	}
}
`
export default getSpecialPrice
